import React from 'react'

import { BottomImageContent, NoImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const General: React.FC<SectionProps> = ({ topicKey, copy }) => {
  const { general_faqs: generalCopyContent } = copy
  const dynamicGoalsSection = {
    'is-my-data-private-and-secure': (
      <NoImageContent
        content={
          <React.Fragment>
            <Text
              content={generalCopyContent.data_private_secure_subheader}
              sx={{ lineHeight: '24px' }}
            />
            <List
              items={[
                buildDynamicCopy(
                  generalCopyContent.data_private_secure_step1,
                  <b>{generalCopyContent.encryption_firewalls_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  generalCopyContent.data_private_secure_step2,
                  <b>{generalCopyContent.secure_authentication_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  generalCopyContent.data_private_secure_step3,
                  <b>{generalCopyContent.privacy_protection_bold_text}</b>,
                  <b>{generalCopyContent.not_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  generalCopyContent.data_private_secure_step4,
                  <b>{generalCopyContent.policy_updates_bold_text}</b>,
                ) as React.ReactNode,
              ]}
            />
          </React.Fragment>
        }
        hasDivider={false}
      />
    ),
    'why-are-some-of-my-transactions-uncategorized': (
      <BottomImageContent
        altImage={topicKey}
        content={
          <React.Fragment>
            <Text content={generalCopyContent.transactions_categorized_subheader} />
            <List
              items={[
                buildDynamicCopy(
                  generalCopyContent.transactions_categorized_step1,
                  <b>{generalCopyContent.checks_atm_withdrawals_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  generalCopyContent.transactions_categorized_step2,
                  <b>{generalCopyContent.limited_transaction_details_bold_text}</b>,
                ) as React.ReactNode,
              ]}
            />
            <Text
              content={generalCopyContent.transactions_uncategorized_subheader}
              sx={{ pt: 12 }}
            />
            <List
              items={[
                buildDynamicCopy(
                  generalCopyContent.transactions_uncategorized_step1,
                  <b>{generalCopyContent.transactions_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  generalCopyContent.transactions_uncategorized_step2,
                  <b>{generalCopyContent.categorize_bold_text}</b>,
                ) as React.ReactNode,
                generalCopyContent.transactions_uncategorized_step3,
                generalCopyContent.transactions_uncategorized_step4,
                generalCopyContent.transactions_uncategorized_step5,
              ]}
              listType="ol"
            />
            <Text
              content={generalCopyContent.transactions_uncategorized_footer_text}
              sx={{ pt: 12 }}
            />
          </React.Fragment>
        }
        hasDivider={false}
        image={HELP_IMAGES.GENERAL_CATEGORIZE_TRANSACTIONS}
        imageLargeBreakPoint={10}
      />
    ),
    'why-cant-i-see-the-software': (
      <NoImageContent
        content={
          <React.Fragment>
            <Text content={generalCopyContent.supported_browser_subheader} />
            <List
              items={[
                generalCopyContent.supported_browser_step1,
                generalCopyContent.supported_browser_step2,
              ]}
            />
            <Text content={generalCopyContent.display_issues_subheader} sx={{ mt: 6 }} />
            <List
              items={[
                buildDynamicCopy(
                  generalCopyContent.display_issues_step1,
                  <b>{generalCopyContent.f12_bold_text}</b>,
                ) as React.ReactNode,
                buildDynamicCopy(
                  generalCopyContent.display_issues_step2,
                  <b>{generalCopyContent.browser_mode_bold_text}</b>,
                ) as React.ReactNode,
                generalCopyContent.display_issues_step3,
                buildDynamicCopy(
                  generalCopyContent.display_issues_step4,
                  <b>{generalCopyContent.document_mode_bold_text}</b>,
                ) as React.ReactNode,
                generalCopyContent.display_issues_step5,
                generalCopyContent.display_issues_step6,
              ]}
            />
            <Text content={generalCopyContent.display_issues_footer_text} sx={{ mt: 6 }} />
          </React.Fragment>
        }
        hasDivider={false}
      />
    ),
    'how-do-i-log-out-of-the-software': (
      <NoImageContent
        content={<Text content={generalCopyContent.log_out_text} />}
        hasDivider={false}
      />
    ),
  }

  return dynamicGoalsSection[topicKey as keyof typeof dynamicGoalsSection]
}

export default General
